export const PLACEHOLDER = '/images/logo.png';
